export class RepositoryException  {
  public message: string = "";
  public code: string = "";

  constructor(message= "", code= "") {
    this.message = message;
    this.code = code;
  }
}

export const error = (e): RepositoryException => {
  // const error = e?.response?.data;
  //
  // if (error && error.code && error.code !== "UNEXPECTED_ERROR") {
  //   return new Exception(error.message, error.code);
  // }
  //
  // return new Exception("Ocorreu um erro inesperado.", "UNEXPECTED_ERROR");
  return e;
};


export class BusinessException {
  /** This is the message that will be displayed to the user.
   * Example if some attribute/field is empty the message probably will be: "This field can not be empty"*/
  private readonly _message: string;

  /** Represents the cause of the error,
   * for example if some attribute/field is empty the cause of error can be: "EMPTY_FIELD".
   * This is used just to developers identify the real cause of the error by an easy way
   * The cause must be written this way: "COMPOSITE_NAME", "NAME" */
  private readonly _cause: string;

  /** Represents the error code as a http error which can be: 500, 400, 404, etc... */
  private readonly _code: number;

  get code(): number {
    return this._code;
  }
  get cause(): string {
    return this._cause;
  }
  get message(): string {
    return this._message;
  }

  constructor(message: string, cause: string, code?: number) {
    this._message = message;
    this._cause = cause;
    this._code = code ?? 0;
  }
}

/** Used to display all BusinessErrors to the user.
 * It will be used in conjunction with BusinessError.
 * It should be called only after some entity passes its respective rules. */
export class BusinessRuleException {
  /** It will receive each BusinessError from an entity when going through their respective rules and failing them. */
  private readonly _errors: Array<BusinessException>;

  constructor(errors: Array<BusinessException>) {
    this._errors = errors;
  }

  get errors(): Array<BusinessException> {
    return this._errors;
  }
}